// Slug-Extraktion aus der URL. Eine SPA-Shell bedient alle `/trips/<slug>/*`
// Routen — den Slug lesen wir zur Laufzeit aus location.pathname.
//
// Beispiele:
//   /trips/                     → null
//   /trips/mai-2026             → 'mai-2026'
//   /trips/mai-2026/plan/       → 'mai-2026'
//   /trips/mai-2026/chat        → 'mai-2026'

const SLUG_REGEX = /^\/trips\/([^/]+)(?:\/|$)/;

export function extractSlugFromPath(pathname: string = window.location.pathname): string | null {
  const match = SLUG_REGEX.exec(pathname);
  return match ? decodeURIComponent(match[1]) : null;
}

export function tripBasename(slug: string): string {
  return `/trips/${encodeURIComponent(slug)}`;
}
